"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ui = require("@unite-us/ui");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var InfoPopover = /*#__PURE__*/function (_Component) {
  _inherits(InfoPopover, _Component);
  var _super = _createSuper(InfoPopover);
  function InfoPopover(props) {
    var _this;
    _classCallCheck(this, InfoPopover);
    _this = _super.call(this, props);
    _this.togglePopover = _this.togglePopover.bind(_assertThisInitialized(_this));
    _this.isTooltip = _this.isTooltip.bind(_assertThisInitialized(_this));
    _this.handleMouseHover = _this.handleMouseHover.bind(_assertThisInitialized(_this));
    _this.state = {
      popoverOpen: false
    };
    return _this;
  }
  _createClass(InfoPopover, [{
    key: "handleMouseHover",
    value: function handleMouseHover(value) {
      this.setState({
        popoverOpen: this.isTooltip() && !this.props.hiddenTooltip && value
      });
    }
  }, {
    key: "togglePopover",
    value: function togglePopover() {
      this.setState({
        popoverOpen: (!this.isTooltip() || !this.props.hiddenTooltip) && !this.state.popoverOpen
      });
    }
  }, {
    key: "isTooltip",
    value: function isTooltip() {
      return 'tooltipText' in this.props;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        id = _this$props.id,
        placement = _this$props.placement,
        boundariesElement = _this$props.boundariesElement,
        iconColor = _this$props.iconColor;
      var anchorId = (0, _utils.getAnchorId)(id);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, 'info-popover'),
        onMouseOver: function onMouseOver() {
          return _this2.handleMouseHover(true);
        },
        onFocus: function onFocus() {
          return _this2.handleMouseHover(true);
        },
        onMouseOut: function onMouseOut() {
          return _this2.handleMouseHover(false);
        },
        onBlur: function onBlur() {
          return _this2.handleMouseHover(true);
        }
      }, this.isTooltip() && children, !this.isTooltip() && /*#__PURE__*/_react["default"].createElement("button", {
        "aria-controls": id,
        "aria-label": (0, _lodash.get)(children, 'props.children', ''),
        id: anchorId,
        onClick: this.togglePopover,
        type: "button",
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconInfoCircle",
        className: "info-popover__icon",
        color: iconColor
      })), /*#__PURE__*/_react["default"].createElement(_ui.Popover, {
        autoFocus: true,
        id: id,
        className: "".concat(className, " z-modal"),
        body: this.isTooltip() && this.props.tooltipText || children,
        isOpen: this.state.popoverOpen,
        placement: placement,
        target: anchorId,
        toggle: this.togglePopover,
        hideArrow: this.isTooltip(),
        boundariesElement: boundariesElement
      }));
    }
  }]);
  return InfoPopover;
}(_react.Component);
InfoPopover.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  /** text to show when using the popover as a tooltip */
  // eslint-disable-next-line react/require-default-props
  tooltipText: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  /** whether the tooltip is hidden or not */
  hiddenTooltip: _propTypes["default"].bool,
  /** Boundaries for popper, can be scrollParent, window, viewport, or any DOM element */
  boundariesElement: _propTypes["default"].string,
  placement: _propTypes["default"].oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),
  /** custom color for icon */
  iconColor: _propTypes["default"].string
};
InfoPopover.defaultProps = {
  children: '',
  className: '',
  hiddenTooltip: true,
  placement: 'top',
  boundariesElement: '',
  iconColor: null
};
var _default = exports["default"] = InfoPopover;